import { Button } from '@/components/ui/Button';
import { tasksText } from '@/i18n/tasks';
import { usePushControls } from './usePush';

/** Sidebar user-row button 'Njoftimet' — rendered only while the notification permission is still 'default'. */
export function NotificationsButton() {
  const { canAsk, ask } = usePushControls();
  if (!canAsk) return null;
  return (
    <Button size="small" id="pushNotificationsBtn" onClick={() => void ask()}>
      {tasksText.push.button}
    </Button>
  );
}
